/**
 * Renders the app header
 */

import React from 'react';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  render() {
    return (
      <header id="header" className="site-head">
        <div className="wrap">
          <h1 className="meta">SmarterProctoring Automated Player</h1>

          <Link
            className="brand"
            to="/"
          >
            <img
              className="brand__logo"
              src={`/static/img/logo.png`}
              alt={`The SmarterProctoring logo`}
              width="150"
            />
          </Link>
        </div>
      </header>
    )
  }
}

export default Header;
